import clsx from 'clsx';
import { forwardRef } from 'react';

import {
  type DataTestId,
  type StylingProps,
  type WithChildren,
} from '@dynatrace/strato-components/core';
import { _canReceiveDefaultTextFormat } from '@dynatrace/strato-components/core';
import { Text } from '@dynatrace/strato-components/typography';

import { accordionLabelCSS } from './Accordion.sty.js';

/** @public */
export type AccordionSectionLabelProps = WithChildren &
  StylingProps &
  DataTestId;

/**
 * Accordion Section Label component
 * @public
 */
export const AccordionSectionLabel = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  AccordionSectionLabelProps
>((props, forwardedRef) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  }: AccordionSectionLabelProps = props;
  const childIsText = _canReceiveDefaultTextFormat(children);

  return (
    <div
      data-testid={dataTestId}
      ref={forwardedRef}
      className={clsx(accordionLabelCSS, consumerClassName)}
      style={consumerStyle}
    >
      {childIsText ? (
        <Text textStyle="base-emphasized" as="p">
          {children}
        </Text>
      ) : (
        children
      )}
    </div>
  );
});

(
  AccordionSectionLabel as typeof AccordionSectionLabel & {
    displayName: string;
  }
).displayName = 'Accordion.SectionLabel';
